<template>
    <section class="question">
        <div class="question__animation" v-if="animation">
            <lottie-player
                ref="lottie"
                class="question__player"
                background="transparent"
                speed="1"
                loop
                autoplay></lottie-player>
        </div>
        <div class="question__content" :class="{'question__content--no-col': !animation}">
            <div class="radios" :class="{'radios--align-left': animation}">
                <p class="supertitle" v-if="questionNumber">otázka {{ questionNumber }}</p>
                <h2 class="title">{{ title }}</h2>
                <ul class="radios__list">
                    <li v-for="(item, i) in items" :key="`${name}-${i}`" class="radios__item">
                        <input type="radio" :id="`${name}-${i}`" :value="item.value" class="radios__input" :name="name">
                        <label :for="`${name}-${i}`" class="radios__label" @click="updateValue(item.value)">
                            {{ item.text }}
                        </label>
                    </li>
                </ul>
                <span class="radios__error" v-if="$v.value.$error && !$v.value.required">Odpovězte prosím na otázku</span>
            </div>
            <slot></slot>
        </div>
    </section>
</template>

<script>
import {required} from 'vuelidate/lib/validators';
import animation from "@/mixins/animation";

export default {
    name: "GroheRadios",
    mixins: [animation],
    props: {
        items: {
            type: Array,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        questionNumber: {
            type: String
        }
    },
    data() {
        return {
            value: null,
        }
    },
    validations: {
        value: {
            required
        },
        form: ['value']
    },
    methods: {
        updateValue(value) {
            this.value = value;
        },
        validate() {
            this.$v.form.$touch();
            const isValid = !this.$v.form.$invalid;
            const value = typeof this.value === 'boolean' ? this.value : parseInt(this.value);
            this.$emit('on-validate', isValid, this.name, value);
            return isValid;
        }
    }
}
</script>

<style lang="scss">
    .radios {
        display: flex;
        flex-direction: column;
        align-items: center;
        &__list {
            list-style: none;
            padding: 0;
            margin: 0;
            width: 100%;
        }
        &__item {
            margin-bottom: 10px;
        }
        &__input {
            display: none;
            &:checked + .radios__label {
                border-color: $crow-black-blue;
                background-color: $calcareous-sinter;
                &:before {
                    background-image: url("~@/assets/check.svg");
                    background-repeat: no-repeat;
                    background-size: 28px;
                    background-position: center;
                }
            }
        }
        &__label {
            position: relative;
            display: flex;
            align-items: center;
            height: 60px;
            padding: 15px 20px 12px 60px;
            font-size: 14px;
            font-family: 'Linotype Univers Bold', sans-serif;
            text-align: left;
            border: 2px solid;
            border-radius: 100px;
            cursor: pointer;
            user-select: none;

            &:before {
                content: '';
                display: block;
                position: absolute;
                top: 16px;
                left: 20px;
                width: 24px;
                height: 24px;
                border-radius: 50%;
                border: 2px solid $crow-black-blue;
            }
        }
        &__error {
            font-size: 16px;
            color: #da5757;
            margin-top: 10px;
        }

        @media screen and (min-width: $mq-sm) {
            &__list {
                min-width: 400px;
                width: auto;
            }
            &__label {
                font-size: 16px;
                padding: 15px 20px 15px 70px;

                &:before {
                    top: 14px;
                    width: 28px;
                    height: 28px;
                }
            }
        }

        @media screen and (min-width: $mq-md) {
            &--align-left {
                align-items: flex-start;
            }
        }
    }
</style>
